// extracted by mini-css-extract-plugin
export default {"container":"_1yvT","image":"a3bS"};